module.exports = __webpack_public_path__ + "img/Group2.47333b93.svg";